module.exports = __webpack_public_path__ + "img/e0251d3.jpg";